import { Button } from '@taskall/react';
import { Card, ErrorState } from '@taskall/ui';
import { useRouteError } from 'react-router-dom';

/** Nunca deixa a tela branca: erro inesperado de renderização/carregamento de rota. */
export function RouteErrorBoundary() {
  const error = useRouteError();
  const chunkError = error instanceof Error && /dynamically imported module|Loading chunk/i.test(error.message);
  return (
    <div className="grid min-h-screen place-items-center bg-[var(--taskall-background-secondary)] p-4">
      <Card className="w-full max-w-lg">
        <ErrorState
          title={chunkError ? 'Uma nova versão está disponível' : 'Algo deu errado'}
          description={chunkError ? 'Recarregue a página para continuar.' : 'Tente novamente. Se o problema persistir, contate o suporte.'}
        />
        <div className="flex justify-center pb-4">
          <Button onClick={() => window.location.reload()}>Recarregar</Button>
        </div>
      </Card>
    </div>
  );
}
